import { PlusCircleFilled } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Button, message } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { UsersSearch } from '@/components'
import { ResourceType } from '@/schemas'

interface AddUserProps {
  type: ResourceType
  selfId: string
  existingEmails: string[]
  onSuccess: () => void
}

export const AddUser: React.FC<AddUserProps> = ({ selfId, existingEmails, onSuccess, type }) => {
  const { t } = useTranslation()
  const [addingUser, setAddingUser] = React.useState(false)

  const { run } = useRequest(
    (email: string) => ({
      url: '/api/userRoles/createResourceUser',
      method: 'post',
      data: {
        selfId: selfId,
        email,
        type,
        role: '成员',
      },
    }),
    {
      manual: true,
    }
  )

  const onChange = async (email?: string) => {
    if (!email) {
      setAddingUser(false)
      return
    }
    if (existingEmails.includes(email)) {
      message.warn(t('already exists'))
      return
    }
    await run(email)
    onSuccess()
    setAddingUser(false)
  }

  return addingUser ? (
    <UsersSearch
      autoFocus
      open
      style={{ width: '90%' }}
      placeholder={t('add users')}
      onChange={onChange}
      onBlur={() => setAddingUser(false)}
    />
  ) : (
    <div className='cursor-pointer flex items-center' onClick={() => setAddingUser(true)}>
      <Button
        type='text'
        icon={<PlusCircleFilled style={{ fontSize: 18 }} />}
        style={{ display: 'flex', alignItems: 'center', paddingLeft: 6 }}
      >
        {t('add users')}
      </Button>
    </div>
  )
}
